import React from "react";
import LinkComp from "../LinkComp";

export default () => {
  return (
    <header className="Header">
      <div className="Header_wrap">
        <LinkComp className="Header_logo" to={arc.path.base}>
          <img src={arc.path.media + "strive.svg"} alt="" />
        </LinkComp>
        <div className="Header_quote">
          "STRIVE not to be a success, but rather to be of value." - Albert Einstein
        </div>
      </div>
    </header>
  );
};
